module.exports = __webpack_public_path__ + "static/media/ii1.28d16104.svg";